import { cx } from '@libs/classnames';

import styles from './RotateBoardButton.module.css';

export function RotateBoardButton({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      className={cx(styles.rotate, className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="32"
      fill="none"
      viewBox="0 0 24 32"
      onClick={onClick}
    >
      <path
        fill="var(--_bg)"
        d="M0 16c0-3.72 0-5.58.409-7.105A12 12 0 0 1 8.895.409C10.42 0 12.28 0 16 0h8v31.999h-8c-3.72 0-5.58 0-7.105-.409a12 12 0 0 1-8.486-8.485C0 21.579 0 19.719 0 15.999"
      />
      <path
        stroke="var(--_fg)"
        strokeOpacity=".1"
        d="M16 .5h7.5v30.999H16c-3.751 0-5.53-.004-6.976-.392a11.5 11.5 0 0 1-8.132-8.132C.504 21.528.5 19.75.5 16s.004-5.53.392-6.976A11.5 11.5 0 0 1 9.024.892C10.471.504 12.25.5 16 .5Z"
      />
      <path
        fill="var(--_fg)"
        d="M15 10.823c-.992 0-1.8.836-1.8 1.862v2.484c0 .341.27.62.6.621.33 0 .6-.28.6-.621v-2.225l1.335 1.381A3.8 3.8 0 0 1 16.8 16.99c0 2.057-1.617 3.747-3.605 3.768a.614.614 0 0 0-.595.627c.004.34.273.614.607.614C15.85 21.972 18 19.724 18 16.99a5.07 5.07 0 0 0-1.418-3.543l-1.335-1.382H17.4c.33 0 .6-.28.6-.622 0-.34-.27-.62-.6-.62zM10.795 10C8.15 10.027 6 12.274 6 15.008a5.07 5.07 0 0 0 1.417 3.544l1.336 1.383H6.6c-.33 0-.6.279-.6.62s.27.62.6.62H9c.993 0 1.8-.835 1.8-1.861V16.83a.61.61 0 0 0-.6-.621c-.33 0-.6.28-.6.621v2.225l-1.334-1.381A3.8 3.8 0 0 1 7.2 15.008c0-2.057 1.617-3.746 3.605-3.767a.613.613 0 0 0 .595-.627.613.613 0 0 0-.607-.614"
      />
    </svg>
  );
}
